import { getRequestStatus } from '../../requests/selectors';
import { PREVIOUS_BOOKING } from './action-types';

export const previousBookingSelector = (state) => state.booking.previousBooking.booking;

export const [getMyBookingSelector, getMyBookingFailedSelector, getMyBookingErrorSelector] =
  getRequestStatus(PREVIOUS_BOOKING);
